import { render, staticRenderFns } from "./DynamicProductPage.vue?vue&type=template&id=15b8e592&scoped=true&"
import script from "./DynamicProductPage.vue?vue&type=script&lang=js&"
export * from "./DynamicProductPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b8e592",
  null
  
)

export default component.exports